'use client'

import { Partner, UserData } from '@/app/lib/definitions'
import { Input, Textarea } from '@nextui-org/input'
import { Spinner } from '@nextui-org/spinner'
import { useEffect, useState } from 'react'

export default function PartnerDataForm({
    user,
}: Readonly<{ user: UserData }>) {
    const [editing, setEditing] = useState(false)
    const [name, setName] = useState<string | null>(null)
    const [phone, setPhone] = useState<string | null>(null)

    const [partnerInfo, setPartnerInfo] = useState<Partner | null>(null)

    const [assocName, setAssocName] = useState<string | null>(null)
    const [city, setCity] = useState<string | null>(null)
    const [province, setProvince] = useState<string | null>(null)
    const [email, setEmail] = useState<string | null>(null)
    const [commEmail, setCommEmail] = useState<string | null>(null)
    const [assocPhone, setAssocPhone] = useState<string | null>(null)
    const [description, setDescription] = useState<string | null>(null)
    const [urlWeb, setUrlWeb] = useState<string | null>(null)
    const [urlIG, setUrlIG] = useState<string | null>(null)
    const [urlFB, setUrlFB] = useState<string | null>(null)

    useEffect(() => {
        if (user.associationId != null) {
            fetch(`/api/getPartner?uid=${user.associationId}`).then(
                async (res) => {
                    const data = (await res.json()) as Partner
                    setPartnerInfo(data)
                }
            )
        }
    }, [])

    const edit = () => {
        setEditing(!editing)
        if (editing === true && user) {
            if (name != null || phone != null) {
                if (phone != null && phone != '' && phone?.length != 10) {
                    alert(
                        'Numero di telefono non valido, inserire un numero valido e riprovare'
                    )
                    return
                }
                try {
                    fetch('/api/editUser', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            uid: user.uid,
                            name: name! ?? user.name,
                            telephoneNumber: phone ?? user.telephoneNumber,
                            email: user.email,
                            type: user.type,
                            events: user.events,
                            associationId: user.associationId,
                            preferedGames: user.preferedGames
                        }),
                    })
                } catch (error) {
                    alert(error)
                    return
                }
            }

            if (
                (assocName ||
                    city ||
                    province ||
                    email ||
                    commEmail ||
                    assocPhone ||
                    description ||
                    urlWeb ||
                    urlIG ||
                    urlFB) != null
            ) {
                if (
                    assocPhone != null &&
                    assocPhone != '' &&
                    assocPhone?.length != 10
                ) {
                    alert(
                        'Numero di telefono non valido, inserire un numero valido e riprovare'
                    )
                    return
                }

                if (
                    province != null &&
                    province != '' &&
                    province.length != 2
                ) {
                    alert(
                        'Provincia non valida, inserire una provincia valida e riprovare'
                    )
                    return
                }

                if (
                    assocName != null &&
                    assocName.replaceAll(" ", "") === ""
                ) {
                    alert(
                        "Nome dell'Associazione non valido, inserire un nome e riprovare"
                    )
                    return
                }

                fetch('api/editPartner', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        id: partnerInfo?.id,
                        name: assocName ?? partnerInfo?.name,
                        referent: partnerInfo?.referent,
                        city: city ?? partnerInfo?.city,
                        province: province ?? partnerInfo?.province,
                        email: email ?? partnerInfo?.email,
                        telephoneNumber:
                            assocPhone ?? partnerInfo?.telephoneNumber,
                        communicationEmail:
                            commEmail ?? partnerInfo?.comunicationEmail,
                        urlWeb: urlWeb ?? partnerInfo?.urlWeb,
                        urlIG: urlIG ?? partnerInfo?.urlIG,
                        urlFB: urlFB ?? partnerInfo?.urlFB,
                        location: partnerInfo?.location,
                        type: partnerInfo?.type,
                        logoUrl: partnerInfo?.logoUrl,
                        linkPodcast: partnerInfo?.linkPodcast,
                        description: description ?? partnerInfo?.description,
                        events: partnerInfo?.events,
                        games: partnerInfo?.games
                    }),
                })
            }
        }
    }

    return (
        <div className="grid grid-cols-1 gap-4 text-lg">
            <div className="flex content-center justify-between">
                <p className="text-2xl font-bold">Informazioni</p>
                <button
                    onClick={() => edit()}
                    className="text-md font-light italic underline transition duration-100 ease-in-out hover:font-semibold"
                >
                    {editing ? 'Salva dati' : 'Modifica'}
                </button>
            </div>
            <p className="text-xl font-semibold italic">Personali</p>
            <Input
                id="name"
                type="text"
                label="Nome"
                defaultValue={user.name ?? '-'}
                size="lg"
                radius="none"
                variant="bordered"
                color="default"
                isDisabled={!editing}
                onValueChange={(value) => {
                    setName(value)
                }}
                classNames={{
                    label: 'z-0',
                    inputWrapper: 'border-black',
                }}
            />
            <Input
                id="email"
                type="text"
                label="Email"
                defaultValue={user.email ?? '-'}
                size="lg"
                radius="none"
                variant="bordered"
                color="default"
                isDisabled={true}
                classNames={{
                    label: 'z-0',
                    inputWrapper: 'border-black',
                }}
            />
            <Input
                id="phone"
                type="number"
                label="Telefono"
                defaultValue={user.telephoneNumber?.toString()}
                size="lg"
                radius="none"
                variant="bordered"
                color="default"
                isDisabled={!editing}
                onValueChange={(value) => {
                    setPhone(value)
                }}
                classNames={{
                    label: 'z-0',
                    inputWrapper: 'border-black',
                }}
            />

            {user.associationId != null && (
                <>
                    {partnerInfo === null && <Spinner color="primary" />}
                    {partnerInfo != null &&
                        partnerInfo.id === user.associationId && (
                            <>
                                <p className="text-xl font-semibold italic">
                                    Associazione
                                </p>
                                <Input
                                    id="assocName"
                                    type="text"
                                    label="Nome"
                                    defaultValue={partnerInfo.name ?? '-'}
                                    size="lg"
                                    radius="none"
                                    variant="bordered"
                                    color="default"
                                    isDisabled={!editing}
                                    onValueChange={(value) => {
                                        setAssocName(value)
                                    }}
                                    classNames={{
                                        label: 'z-0',
                                        inputWrapper: 'border-black',
                                    }}
                                />
                                <div className="grid grid-cols-2 gap-2">
                                    <Input
                                        id="city"
                                        type="text"
                                        label="Città"
                                        defaultValue={partnerInfo.city ?? ''}
                                        size="lg"
                                        radius="none"
                                        variant="bordered"
                                        color="default"
                                        isDisabled={!editing}
                                        onValueChange={(value) => {
                                            setCity(value)
                                        }}
                                        classNames={{
                                            label: 'z-0',
                                            inputWrapper: 'border-black',
                                        }}
                                    />
                                    <Input
                                        id="province"
                                        type="text"
                                        label="Provincia"
                                        defaultValue={
                                            partnerInfo.province ?? ''
                                        }
                                        size="lg"
                                        radius="none"
                                        variant="bordered"
                                        color="default"
                                        isDisabled={!editing}
                                        onValueChange={(value) => {
                                            setProvince(value)
                                        }}
                                        classNames={{
                                            label: 'z-0',
                                            inputWrapper: 'border-black',
                                        }}
                                    />
                                </div>
                                <Input
                                    id="assocEmail"
                                    type="text"
                                    label="Email"
                                    defaultValue={partnerInfo.email ?? ''}
                                    size="lg"
                                    radius="none"
                                    variant="bordered"
                                    color="default"
                                    isDisabled={!editing}
                                    onValueChange={(value) => {
                                        setEmail(value)
                                    }}
                                    classNames={{
                                        label: 'z-0',
                                        inputWrapper: 'border-black',
                                    }}
                                />
                                <Input
                                    id="commEmail"
                                    type="text"
                                    label="Email per Comunicazioni"
                                    defaultValue={
                                        partnerInfo.comunicationEmail ?? ''
                                    }
                                    size="lg"
                                    radius="none"
                                    variant="bordered"
                                    color="default"
                                    isDisabled={!editing}
                                    onValueChange={(value) => {
                                        setCommEmail(value)
                                    }}
                                    classNames={{
                                        label: 'z-0',
                                        inputWrapper: 'border-black',
                                    }}
                                />
                                <Input
                                    id="assocPhone"
                                    type="text"
                                    label="Telefono"
                                    defaultValue={
                                        partnerInfo.telephoneNumber?.toString() ??
                                        ''
                                    }
                                    size="lg"
                                    radius="none"
                                    variant="bordered"
                                    color="default"
                                    isDisabled={!editing}
                                    onValueChange={(value) => {
                                        setAssocPhone(value)
                                    }}
                                    classNames={{
                                        label: 'z-0',
                                        inputWrapper: 'border-black',
                                    }}
                                />
                                <Textarea
                                    id="description"
                                    type="text"
                                    placeholder="Descrizione"
                                    size="lg"
                                    radius="none"
                                    variant="bordered"
                                    color="default"
                                    minRows={8}
                                    isDisabled={!editing}
                                    defaultValue={partnerInfo.description ?? ''}
                                    onValueChange={(value) => {
                                        setDescription(value)
                                    }}
                                    classNames={{
                                        label: 'z-0',
                                        inputWrapper: 'border-black',
                                    }}
                                />
                                <Input
                                    id="urlWeb"
                                    type="text"
                                    label="Link al sito web"
                                    defaultValue={partnerInfo.urlWeb ?? ''}
                                    size="lg"
                                    radius="none"
                                    variant="bordered"
                                    color="default"
                                    isDisabled={!editing}
                                    onValueChange={(value) => {
                                        setUrlWeb(value)
                                    }}
                                    classNames={{
                                        label: 'z-0',
                                        inputWrapper: 'border-black',
                                    }}
                                />
                                <Input
                                    id="urlIG"
                                    type="text"
                                    label="Link alla pagina Instagram"
                                    defaultValue={partnerInfo.urlIG ?? ''}
                                    size="lg"
                                    radius="none"
                                    variant="bordered"
                                    color="default"
                                    isDisabled={!editing}
                                    onValueChange={(value) => {
                                        setUrlIG(value)
                                    }}
                                    classNames={{
                                        label: 'z-0',
                                        inputWrapper: 'border-black',
                                    }}
                                />
                                <Input
                                    id="urlFB"
                                    type="text"
                                    label="Link alla pagina Facebook"
                                    defaultValue={partnerInfo.urlFB ?? ''}
                                    size="lg"
                                    radius="none"
                                    variant="bordered"
                                    color="default"
                                    isDisabled={!editing}
                                    onValueChange={(value) => {
                                        setUrlFB(value)
                                    }}
                                    classNames={{
                                        label: 'z-0',
                                        inputWrapper: 'border-black',
                                    }}
                                />
                                { user.type === 'admin' &&
                                    <Input
                                        id="referentEmail"
                                        type="text"
                                        label="Account collegato"
                                        defaultValue={partnerInfo.user != null ? partnerInfo.user.email : 'Nessuno'}
                                        size="lg"
                                        radius="none"
                                        variant="bordered"
                                        color="default"
                                        isDisabled={true}
                                        classNames={{
                                            label: 'z-0',
                                            inputWrapper: 'border-black',
                                        }}
                                    />
                                }
                            </>
                        )}
                </>
            )}
        </div>
    )
}
